module.exports = __webpack_public_path__ + "img/027.d30ca205.jpg";